// Header.jsx
import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import Logo from '../Images/imaven-logo-blue.png';
import DemoAvater from '../Images/demoAvater.svg';
import SettingIcon from '../Images/settins-icon.svg';
import NotificationIcon from '../Images/notification-icon.svg';
import MessagesIcon from '../Images/messages-icon.svg';
import TutorialIcon from '../Images/question-mark-icon.svg';
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from 'react-router-dom';

const HeaderContainer = styled.div`
  width: 100%;
  height: 5%;
  background: rgba(250, 252, 255, 0.83);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2000;
  border-bottom: 1px solid rgba(207, 218, 237, 0.63);
  
  @media (max-width: 768px) {
    height: 50px;
    min-height: 50px;
    padding: 0;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2000;
  }
`;

const LogoContainer = styled.div`
  padding: 12px 8px;
  margin-left: 0;
  display: flex;
  align-items: center;
  
  gap: 9px;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -1px;
  color: #172847;

  img {
    height: 30px;
    width: auto;

    @media (max-width: 768px) {
      height: 26px;
    }
  }

  small {
    align-self: flex-start;
    margin-top: 2px;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.02em;
    color: #885de8;
  }

  @media (max-width: 768px) {
    font-size: 19px;
  }
  
  @media (max-width: 480px) {
    padding: 12px 8px;
    margin-left: 0;
  }
`;

const SettingsButton = styled.div`
  margin-right: 20px;
  display: flex;
  align-items: center;
  
  @media (max-width: 480px) {
    margin-right: 10px;
  }
`;

const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;
  margin-left: 20px;
  border: 2px solid #e0e8f5;
  box-shadow: 0 2px 6px rgba(39, 68, 131, 0.07);
  
  @media (max-width: 480px) {
    width: 32px;
    height: 32px;
  }
`;

const IconContainer = styled.div`
  display: flex;
  position: relative;
  margin-left: 20px;
  cursor: pointer;
  opacity: 0.7;
  transition: all 0.3s;
  padding: 8px;
  border-radius: 50%;
  
  &:hover {
    opacity: 1;
    background-color: #edf2ff;
  }
  
  &.disabled {
    cursor: not-allowed;
    opacity: 0.4;
    
    &:hover {
      background-color: transparent;
    }
  }
  
  img {
    width: 24px;
    height: 24px;
    filter: brightness(0) saturate(100%) invert(34%) sepia(15%) saturate(1133%) hue-rotate(179deg) brightness(88%) contrast(88%);
    
    @media (max-width: 480px) {
      width: 20px;
      height: 20px;
    }
  }
  
  @media (max-width: 480px) {
    margin-left: 12px;
    padding: 6px;
    
    &.disabled {
      cursor: not-allowed;
    }
  }
`;

const Badge = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  width: 10px;
  height: 10px;
  background-color: #335cf4;
  border-radius: 50%;
  display: ${({ $showBadge }) => ($showBadge ? 'block' : 'none')};
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 50px;
  right: 0;
  width: 200px;
  background: #ffffff;
  border: 1px solid #e0e8f5;
  border-radius: 12px;
  box-shadow: 0 20px 50px rgba(17, 40, 74, 0.12);
  overflow: hidden;
  z-index: 100000;
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
`;

const MenuItem = styled.div`
  padding: 12px 16px;
  color: #192947;
  font-size: 14px;
  transition: all 0.2s;
  
  &:hover {
    background-color: #f5f8fd;
    color: #335cf4;
  }
`;

const Header = ({ onExpandToggle, expanded }) => {
  const { user, isAuthenticated } = useAuth0();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const settingsRef = useRef(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const closeTimeoutRef = useRef(null);

  const handleContactUsClick = () => {
    navigate('/contact-us');
    setSettingsOpen(false);
  };

  const handleSettingsClick = () => {
    navigate('/settings');
    setSettingsOpen(false);
  };

  const handleHelpClick = () => {
    window.open('https://www.imavenai.com/tutorials', '_blank', 'noopener,noreferrer');
  };

  const isMenuOpen = settingsOpen;

  if (!user && !isAuthenticated) {
    return (<div></div>)
  }

  return (
    <HeaderContainer>
      <LogoContainer>
        <img alt='' src={Logo} />
        <span>iMaven</span><small>AI</small>
      </LogoContainer>

      <SettingsButton>
        {/* <IconContainer>
          <img src={MessagesIcon} alt="Message Icon" />
          <Badge $showBadge={false} />
        </IconContainer>

        <IconContainer>
          <img src={NotificationIcon} alt="Notification Icon" />
          <Badge $showBadge={false} />
        </IconContainer> */}

        <IconContainer onClick={handleHelpClick}>
          <img src={TutorialIcon} alt="Tutorials" />
        </IconContainer>

        <IconContainer
          ref={settingsRef}
          onClick={() => setSettingsOpen(!settingsOpen)}
        >
          <img src={SettingIcon} alt="Setting Icon" />
          <DropdownMenu
            ref={dropdownRef}
            $isOpen={isMenuOpen}
          >
            <MenuItem onClick={handleContactUsClick}>Contact us</MenuItem>
            <MenuItem onClick={handleSettingsClick}>Profile</MenuItem>
          </DropdownMenu>
        </IconContainer>

        <Avatar src={user.picture} alt="User Avatar"></Avatar>
      </SettingsButton>
    </HeaderContainer>
  );
};

export default Header;